/**
 * Fishermans — Carrinho da PDP do alicate.
 *
 * ESCOPO: carrega SÓ pelo template do alicate. Não toca no layout do tema.
 *
 * ── O PROBLEMA ────────────────────────────────────────────────────────────
 * `snippets/cart-drawer.liquid` (linha 22) escreve `is-empty` na tag raiz
 * <cart-drawer> quando `cart == empty`. Nenhum JS do tema remove essa classe
 * (0 arquivos em assets/*.js a mencionam; só o base.css a consome):
 *
 *   cart-drawer.is-empty .drawer__header,
 *   cart-drawer.is-empty .cart-drawer__body,
 *   cart-drawer.is-empty .drawer__footer { height:0; padding:0; overflow:hidden }
 *
 * O botão nativo do tema, ao adicionar, troca só o HTML INTERNO do drawer.
 * Se o carrinho passou por vazio, a classe da raiz fica presa e o conteúdo
 * fica com altura 0 — o item está no carrinho, mas parece que não abriu.
 *
 * ── POR QUE AS PÁGINAS DE LINHA NÃO TÊM ISSO ──────────────────────────────
 * (achado do Jorge, e é a peça que fechou o diagnóstico)
 * O `fishermans-v3-pdp.js` das linhas não usa o submit do tema: ele mesmo faz
 * POST /cart/add.js pedindo `sections` e injeta o wrapper
 * #shopify-section-cart-drawer INTEIRO de volta — trocando a raiz e a classe
 * junto. Por isso a classe nunca fica presa lá.
 *
 * ── A CORREÇÃO ────────────────────────────────────────────────────────────
 * Fazer o alicate usar o MESMO caminho das linhas, que já roda em 11 páginas
 * no ar. Não é remendo sobre o fluxo do tema: é usar o fluxo que funciona.
 * Se qualquer coisa falhar, cai no submit nativo do tema (comportamento de
 * hoje) — nunca deixa o cliente sem conseguir comprar.
 */
(function () {
  "use strict";

  try {
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) { return; }

  var SECTIONS = "cart-drawer,cart-icon-bubble,cart-notification";

  function drawer() {
    try { return document.querySelector("cart-drawer"); } catch (e) { return null; }
  }

  /* Substitui o wrapper INTEIRO da seção — é isso que zera a classe presa. */
  function injectSection(sectionId, html) {
    if (!html) return false;
    try {
      var wrapper = document.getElementById("shopify-section-" + sectionId);
      if (wrapper) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("shopify-section-" + sectionId);
        wrapper.innerHTML = fresh ? fresh.innerHTML : html;
        return true;
      }
      var el = document.getElementById(sectionId) || document.querySelector(sectionId);
      if (el) {
        var d2 = new DOMParser().parseFromString(html, "text/html");
        var f2 = d2.getElementById(sectionId);
        el.innerHTML = f2 ? f2.innerHTML : html;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    try {
      /* rede de segurança: se a classe presa sobreviveu, tira na mão */
      if (d.querySelector(".cart-drawer-item") && d.classList.contains("is-empty")) {
        d.classList.remove("is-empty");
      }
      if (d.classList.contains("active")) return;
      if (typeof d.open === "function") { d.open(); return; }
      d.classList.add("active");
    } catch (e) {}
  }

  /*
   * Acha o form do PRODUTO — e só ele.
   *
   * Cuidado: a pagina tem 4 forms apontando pra /cart/add, e o PRIMEIRO do DOM
   * e o de brinde do carrinho (id "cart-drawer-gift-..."). Pegar
   * querySelector('form[action*="/cart/add"]') prende no form errado.
   * Tambem existe o "product-form-installment-..." (parcelamento), que nao e ele.
   *
   * O certo e o form dentro de <product-form> que tenha input[name="id"] e
   * botao de submit.
   */
  function productForm() {
    var cands = [];
    try {
      cands = Array.prototype.slice.call(
        document.querySelectorAll('product-form form[action*="/cart/add"]')
      );
      if (!cands.length) {
        cands = Array.prototype.slice.call(
          document.querySelectorAll('form[action*="/cart/add"]')
        );
      }
    } catch (e) { return null; }

    for (var i = 0; i < cands.length; i++) {
      var f = cands[i];
      var id = f.getAttribute("id") || "";
      if (id.indexOf("installment") >= 0) continue;
      if (id.indexOf("gift") >= 0) continue;
      if (!f.querySelector('[name="id"]')) continue;
      if (!f.querySelector('button[type="submit"], input[type="submit"]')) continue;
      return f;
    }
    return null;
  }

  /*
   * Le o carrinho do kit montado pela pagina e carimba a adicao.
   *
   * Carimbo unico por clique: sem ele o Shopify FUNDE linhas iguais e dois
   * kits viram "Oceanica x2" dentro do primeiro.
   */
  function kitItens() {
    try {
      var caixa = document.querySelector("[data-fm-kit-items]");
      if (!caixa) return null;
      var lista = JSON.parse(caixa.textContent || "[]");
      if (!Array.isArray(lista) || !lista.length) return null;
      var carimbo = String(Date.now()) + "-" + Math.random().toString(36).slice(2, 7);
      lista.forEach(function (it) {
        it.properties = it.properties || {};
        it.properties["_KitId"] = carimbo;
      });
      return lista;
    } catch (e) { return null; }
  }

  function boot() {
    var form = productForm();
    if (!form) return;

    /* o script pode chegar por mais de um caminho: marca e não duplica */
    try {
      if (form.getAttribute("data-fm-cart") === "on") return;
      form.setAttribute("data-fm-cart", "on");
    } catch (e) { return; }

    var inFlight = false;

    /*
     * DUPLA ADICAO — por que escutamos no `document` em fase de CAPTURA.
     *
     * O <product-form> do tema tambem registra um listener de "submit" NO FORM
     * e faz o proprio POST /cart/add. `preventDefault()` NAO impede outros
     * listeners do mesmo elemento — pra isso precisaria de
     * stopImmediatePropagation() E ser o primeiro registrado, o que nao
     * controlamos (o custom element se registra no upgrade, antes de nos).
     * Resultado: os dois adicionavam, e o cliente levava 2 alicates.
     *
     * Escutando no `document` com capture:true, o nosso roda ANTES de qualquer
     * listener no form, e `stopPropagation()` impede que o evento chegue ao
     * handler do tema. Uma unica adicao, garantida.
     *
     * So agimos se o alvo for EXATAMENTE o form do produto desta pagina —
     * qualquer outro form (brinde, parcelamento, busca, newsletter) passa
     * intacto.
     */
    document.addEventListener("submit", function (evt) {
      if (evt.target !== form) return;

      var idInput, id;
      try {
        idInput = form.querySelector('[name="id"]');
        id = idInput && parseInt(String(idInput.value), 10);
      } catch (e) {}
      if (!id) return; // sem variante resolvida: deixa o tema cuidar

      var qty = 1;
      try {
        var q = form.querySelector('[name="quantity"]');
        if (q && parseInt(q.value, 10) > 0) qty = parseInt(q.value, 10);
      } catch (e) {}

      /* Line item properties (ex.: escolhas de bitola nos kits).
         Sem isto, interceptar o submit PERDERIA as escolhas do cliente e o
         pedido chegaria sem saber qual bitola separar.
         Retrocompatível: se o form não tem properties[...], `props` fica
         vazio e nada muda pras páginas que já estão no ar.

         form.elements, NÃO form.querySelectorAll: nos kits os campos de
         escolha ficam num bloco ACIMA do bloco de botões, ou seja fora do
         <form> no DOM, e se ligam a ele pelo atributo form="...". Uma busca
         por descendentes não enxerga esses campos — foi assim que o pedido
         F30347 chegou sem bitola. form.elements enxerga os dois casos. */
      var props = null;
      try {
        Array.prototype.slice.call(form.elements).forEach(function (el) {
          var n = el.getAttribute && el.getAttribute("name");
          if (!n || n.slice(0, 11) !== "properties[") return;
          if (el.disabled) return;
          if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
          var nome = el.getAttribute("name").slice("properties[".length, -1);
          if (!nome || el.value === "") return;
          props = props || {};
          props[nome] = el.value;
        });
      } catch (e) {}

      evt.preventDefault();
      evt.stopPropagation();

      /* trava de clique duplo: dois cliques rapidos nao viram dois itens */
      if (inFlight) return;
      inFlight = true;

      var btns = form.querySelectorAll('button[type="submit"], [data-fm-atc]');
      try { btns.forEach(function (b) { b.setAttribute("aria-busy", "true"); }); } catch (e) {}

      function release() {
        inFlight = false;
        try { btns.forEach(function (b) { b.removeAttribute("aria-busy"); }); } catch (e) {}
      }

      /*
       * KIT: manda as 3 linhas reais em vez de uma linha do kit.
       * Lista vazia, ausente ou JSON quebrado cai no caminho de sempre.
       */
      var itens = kitItens();
      var ehKit = !!itens;
      if (!itens) {
        itens = [props ? { id: id, quantity: qty, properties: props }
                       : { id: id, quantity: qty }];
      }

      /*
       * Abre a gaveta JA, com "Adicionando <kit>...", em vez de deixar a
       * pagina muda ate a resposta chegar e entao despejar tudo de uma vez.
       * E o que a Dr. Squatch faz: o card do bundle aparece na hora e so o
       * rotulo diz que ainda esta processando.
       * So no kit — produto avulso segue como hoje.
       */
      if (ehKit) {
        try {
          var nomeKit = (itens[0] && itens[0].properties && itens[0].properties["Kit"]) || "";
          openDrawer();
          if (window.FMCart && window.FMCart.aviso) {
            window.FMCart.aviso(nomeKit ? "Adicionando " + nomeKit + "…" : "Adicionando o kit…");
          }
        } catch (e) {}
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: itens,
          sections: SECTIONS,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart");
          return res.json();
        })
        .then(function (data) {
          release();
          try { if (window.FMCart && window.FMCart.limparAviso) window.FMCart.limparAviso(); } catch (e) {}
          var refreshed = false;
          if (data && data.sections) {
            Object.keys(data.sections).forEach(function (sid) {
              if (injectSection(sid, data.sections[sid])) refreshed = true;
            });
          }
          if (refreshed) {
            openDrawer();
          } else {
            /* Section Rendering não pegou: recarrega e abre — igual a v3 faz */
            try { sessionStorage.setItem("fm_open_cart", "1"); } catch (e) {}
            window.location.reload();
          }
        })
        .catch(function () {
          /* último recurso: submit nativo, o comportamento de hoje.
             form.submit() NÃO dispara o evento "submit", então não recursiona. */
          release();
          try { if (window.FMCart && window.FMCart.limparAviso) window.FMCart.limparAviso(); } catch (e) {}
          try { form.submit(); } catch (e) {}
        });
    }, true); // capture: roda antes do listener do tema no form

    /*
     * ── FINALIZAR COMPRA ────────────────────────────────────────────────
     *
     * O botao "FINALIZAR COMPRA" do tema e `type="button"` com
     * `data-skip-cart-button`: ele NAO envia o formulario, o proprio tema
     * adiciona e manda pro checkout. Sem evento de submit, o guard acima
     * nunca via esse clique — e o kit ia pro pedido como UMA linha, com a
     * variante do kit. Foi assim que sairam os pedidos F30597 e F30601.
     *
     * Aqui o clique e interceptado na CAPTURA, antes do handler do tema.
     *
     * So agimos quando a pagina montou um carrinho de kit. Em produto
     * normal a lista vem vazia, nao fazemos nada e o botao segue como hoje
     * — nenhuma outra pagina do site muda de comportamento.
     */
    document.addEventListener("click", function (evt) {
      var btn = null;
      try {
        btn = evt.target && evt.target.closest
          ? evt.target.closest("[data-skip-cart-button]")
          : null;
      } catch (e) {}
      if (!btn) return;
      /* o fallback abaixo reclica o botao pro tema assumir; sem esta marca
         o clique voltaria pra ca e viraria laco infinito */
      if (btn.getAttribute("data-fm-passou") === "1") return;

      var itensKit = kitItens();
      if (!itensKit) return;           /* produto normal: nao e problema nosso */

      evt.preventDefault();
      evt.stopPropagation();
      if (inFlight) return;
      inFlight = true;
      try { btn.setAttribute("aria-busy", "true"); } catch (e) {}

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: itensKit })
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart");
          window.location.href = "/checkout";
        })
        .catch(function () {
          /* ultimo recurso: devolve o clique pro tema, pra nunca travar a venda */
          inFlight = false;
          try { btn.removeAttribute("aria-busy"); } catch (e) {}
          try { btn.setAttribute("data-fm-passou", "1"); btn.click(); } catch (e) {}
        });
    }, true);

    /*
     * Solta a trava de clique duplo quando a pagina VOLTA do historico.
     *
     * O bug que o Jorge pegou: ao mandar pro checkout eu marco inFlight e
     * nunca desmarco, porque a pagina navega. So que o navegador guarda a
     * pagina viva (bfcache) — na volta ela reaparece com a trava presa e o
     * botao fica morto. `pageshow` com persisted=true e o unico evento que
     * dispara nessa restauracao.
     */
    window.addEventListener("pageshow", function (e) {
      if (!e.persisted) return;
      inFlight = false;
      try {
        document.querySelectorAll('[aria-busy="true"]').forEach(function (b) {
          b.removeAttribute("aria-busy");
        });
      } catch (err) {}
    });

    /* voltou de um reload nosso? abre o carrinho */
    try {
      if (sessionStorage.getItem("fm_open_cart")) {
        sessionStorage.removeItem("fm_open_cart");
        setTimeout(openDrawer, 300);
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
